export default "__VITE_ASSET__98e22d6e__"